import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  style: {"max-height":"20rem","overflow-y":"scroll","margin-top":"1rem"}
}

import { RelationStats } from "../statistics";
import { ref, watch, onMounted, computed } from "vue";
import { useRelations } from "../relations";
import { getRelationLabel } from "../tools";
import { chartColors } from "../config";


export default /*#__PURE__*/_defineComponent({
  props: {
    relation: null,
    traductionKey: null,
    stats: null
  },
  setup(__props: any) {

const props = __props as {
    relation: string;
    traductionKey: string;
    stats: RelationStats;
}



const chartRef = ref<HTMLCanvasElement | null>(null);
const chart = ref<any>(null);
const sorted = computed(() =>
    Object.entries(props.stats.counts).sort(([, a], [, b]) => b.value - a.value)
);

const statsToChartData = () => {
    if (chart.value) chart.value.resize();

    return {
        labels: sorted.value.map(
            ([key, data]) =>
                getRelationLabel(props.traductionKey, key) +
                " (" +
                data.value +
                ")"
        ),
        datasets: [
            {
                // data: Object.values(stats.counts).map((data) => data.value),
                data: Object.values(sorted.value).map(([, data]) => data.value),
            },
        ],
    };
};

watch(
    () => props.stats,
    () => {
        if (!chart.value) return;
        chart.value.data = statsToChartData();
    }
);

watch(useRelations(), (rels, prev) => {
    if (!chart.value) return;
    if (!prev[props.relation] && rels[props.relation]) {
        chart.value.data = statsToChartData();
    }
});

watch(chartRef, (ref) => {
    if (!ref) return;
    if (!chart.value) return;
    chart.value.resize();
});

onMounted(() => {
    if (!chartRef.value) return;
    const Chart = (window as any).Chart;
    chart.value = new Chart(chartRef.value, {
        type: "pie",
        data: statsToChartData(),
        options: {
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
                legend: {
                    display: false,
                },
            },
        },
        plugins: [
            {
                id: "customCanvasBackgroundColor",
                beforeDraw: (chart: any) => {
                    const { ctx } = chart;
                    ctx.save();
                    ctx.globalCompositeOperation = "destination-over";
                    ctx.fillStyle = "rgb(239, 244, 249)";
                    ctx.fillRect(0, 0, chart.width, chart.height);
                    ctx.restore();
                },
            },
        ],
    }) as any;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("canvas", {
        ref_key: "chartRef",
        ref: chartRef,
        width: "220",
        id: __props.relation + '-chart'
      }, null, 8, _hoisted_1)
    ]),
    (chart.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sorted), ([key, data], i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              style: {"display":"flex","align-items":"center","margin":"0.25rem 0","gap":"0.5rem"}
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({
                    backgroundColor: _unref(chartColors)[i % _unref(chartColors).length],
                    width: '1rem',
                    height: '1rem',
                    aspectRatio: '1 / 1',
                    display: 'inline-block',
                })
              }, null, 4),
              _createElementVNode("span", null, _toDisplayString(_unref(getRelationLabel)(__props.traductionKey, key)) + " (" + _toDisplayString(data.value) + ") ", 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})